import { icedOutIntroLyrics } from "@/lyrics/01-iced-out-intro-lyrics";
import { icedOutLyrics } from "@/lyrics/02-iced-out-lyrics";
import { imNotLeavingHimLyrics } from "@/lyrics/03-im-not-leaving-him-lyrics";
import { favoriteLyrics } from "@/lyrics/04-favorite-lyrics";
import { foldLyrics } from "@/lyrics/05-fold-lyrics";
import { beggingAndChoosingLyrics } from "@/lyrics/06-begging-and-choosing-lyrics";
import { babylonLyrics } from "@/lyrics/07-babylon-lyrics";
import { mamaLyrics } from "@/lyrics/08-mama-lyrics";
import { letGoLyrics } from "@/lyrics/09-let-go-lyrics";
import { iNoLongerLyrics } from "@/lyrics/10-i-no-longer-lyrics";
import { reflectionLyrics } from "@/lyrics/11-reflection-lyrics";
import { thatsHowLoveGoesLyrics } from "@/lyrics/12-thats-how-love-goes-lyrics";
import { minkMinkMinkLyrics } from "@/lyrics/13-mink-mink-mink-lyrics";
import { coldShouldersLyrics } from "@/lyrics/14-cold-shoulders-lyrics";
import { ashtrayLyrics } from "@/lyrics/15-ashtray-lyrics";

export type LyricLine = {
  readonly text: string;
  /** Seconds from track start; when set with `end`, enables sync highlighting. */
  readonly start?: number;
  readonly end?: number;
};

export interface Song {
  id: number;
  /** MongoDB `tracks` collection `_id` (hex string). */
  trackId: string;
  title: string;
  artist: string;
  album: string;
  duration: string;
  audioUrl: string;
  lyrics?: readonly LyricLine[];
}

function parseDurationToSeconds(duration: string): number {
  const parts = duration.split(":").map((p) => Number.parseInt(p, 10));
  if (parts.some(Number.isNaN)) return 0;
  if (parts.length === 2) {
    const minutes = parts[0] ?? 0;
    const seconds = parts[1] ?? 0;
    return minutes * 60 + seconds;
  }
  if (parts.length === 3) {
    const hours = parts[0] ?? 0;
    const minutes = parts[1] ?? 0;
    const seconds = parts[2] ?? 0;
    return hours * 3600 + minutes * 60 + seconds;
  }
  return 0;
}

/** Artist, track count, and total runtime derived from `album` track durations. */
export function formatAlbumSubtitle(songs: readonly Song[]): string {
  if (songs.length === 0) return "";
  const artist = songs[0]?.artist ?? "";
  const trackCount = songs.length;
  const totalSeconds = songs.reduce((acc, s) => acc + parseDurationToSeconds(s.duration), 0);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const trackLabel = trackCount === 1 ? "track" : "tracks";
  return `${artist} · ${trackCount} ${trackLabel} · ${minutes}m ${seconds}s`;
}

export const album: Song[] = [
  {
    id: 1,
    trackId: "699359e629f95ee4e9d6a877",
    title: "Iced Out (Intro)",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "1:01",
    audioUrl: "/assets/audio/01-iced-out-intro.mp3",
    lyrics: icedOutIntroLyrics,
  },
  {
    id: 2,
    trackId: "699359e629f95ee4e9d6a87b",
    title: "Iced Out",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "2:57",
    audioUrl: "/assets/audio/02-iced-out.mp3",
    lyrics: icedOutLyrics,
  },
  {
    id: 3,
    trackId: "69a054df4e722d84b04f1213",
    title: "I'm not leavin' him",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "3:07",
    audioUrl: "/assets/audio/03-im-not-leaving-him.mp3",
    lyrics: imNotLeavingHimLyrics,
  },
  {
    id: 4,
    trackId: "69f8c94a6d58dbf455c191b7",
    title: "Favorite",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "3:29",
    audioUrl: "/assets/audio/04-favorite.mp3",
    lyrics: favoriteLyrics,
  },
  {
    id: 5,
    trackId: "69f8c94a6d58dbf455c191b8",
    title: "Fold",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "3:21",
    audioUrl: "/assets/audio/05-fold.mp3",
    lyrics: foldLyrics,
  },
  {
    id: 6,
    trackId: "69f8c94a6d58dbf455c191b9",
    title: "Beggin & Choosin",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "4:43",
    audioUrl: "/assets/audio/06-begging-and-choosing.mp3",
    lyrics: beggingAndChoosingLyrics,
  },
  {
    id: 7,
    trackId: "69f8c94a6d58dbf455c191ba",
    title: "Babylon",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "2:42",
    audioUrl: "/assets/audio/07-babylon.mp3",
    lyrics: babylonLyrics,
  },
  {
    id: 8,
    trackId: "69f8c94a6d58dbf455c191bb",
    title: "Mama",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "3:15",
    audioUrl: "/assets/audio/08-mama.mp3",
    lyrics: mamaLyrics,
  },
  {
    id: 9,
    trackId: "69f8c94a6d58dbf455c191bc",
    title: "Let Go",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "3:44",
    audioUrl: "/assets/audio/09-let-go.mp3",
    lyrics: letGoLyrics,
  },
  {
    id: 10,
    trackId: "69f8c94a6d58dbf455c191bd",
    title: "I no longer",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "4:21",
    audioUrl: "/assets/audio/10-i-no-longer.mp3",
    lyrics: iNoLongerLyrics,
  },
  {
    id: 11,
    trackId: "69f8c94a6d58dbf455c191be",
    title: "Reflection",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "4:19",
    audioUrl: "/assets/audio/11-reflection.mp3",
    lyrics: reflectionLyrics,
  },
  {
    id: 12,
    trackId: "69f8c94a6d58dbf455c191bf",
    title: "That's how love goes",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "4:06",
    audioUrl: "/assets/audio/12-thats-how-love-goes.mp3",
    lyrics: thatsHowLoveGoesLyrics,
  },
  {
    id: 13,
    trackId: "69f8c94a6d58dbf455c191c0",
    title: "MinkMinkMink",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "3:46",
    audioUrl: "/assets/audio/13-mink-mink-mink.mp3",
    lyrics: minkMinkMinkLyrics,
  },
  {
    id: 14,
    trackId: "6a04a59037de3e773455aac9",
    title: "Cold Shoulders",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "3:37",
    audioUrl: "/assets/audio/14-cold-shoulders.mp3",
    lyrics: coldShouldersLyrics,
  },
  {
    id: 15,
    trackId: "6a04a59737de3e773455aaca",
    title: "Ashtray",
    artist: "Kennedy Ryon",
    album: "Can I Evolve?",
    duration: "3:42",
    audioUrl: "/assets/audio/15-ashtray.mp3",
    lyrics: ashtrayLyrics,
  },
];
